module.exports = __webpack_public_path__ + "static/flags/NL-294d3f78c4060b754e0b2b8480aa8c52.gif";